import {getCookie,setCookie,deleteCookie} from "@js/globalFunctions/cookieHandling";

export function handleLocalExternalIp()
{
	if( getCookie('hasCheckedIp') !== 'true' )
	{
		jQuery.ajax({
			url: ajaxurl,
			type: 'POST',
			data: {'action': 'returnSenderIp'},
			success: function (data)
			{
				let json = false;
				try
				{
					json = JSON.parse(data);
				}
				catch (e)
				{
					console.log(e);
				}
				
				let now = new Date();
				let time = now.getTime();
				time += 24 * 3600 * 1000;
				now.setTime(time);
				
				if (json !== false && typeof json.client_ip !== 'undefined')
				{
					const checkingIps = ['217.198.217.138','217.198.211.138', '89.249.0.170', '212.112.130.156', '212.98.116.18', '149.202.164.203', '31.185.94.9', '89.184.152.245', '87.51.251.118', '217.198.211.194', '217.198.211.166', '176.20.229.57', '78.143.96.185', '31.185.94.4','212.112.156.165'];
					if( checkingIps.indexOf(json.client_ip) !== -1 )
					{
						console.log('is internal');
						setCookie('internal_ip',true,24);
						document.cookie = 'internal_ip=true; expires=' + now.toUTCString() + ';path=/';
					}
					else
					{
						deleteCookie('internal_ip');
						console.log('isnt internal');
					}
				}
				setCookie('hasCheckedIp',true,24);
			}
		});
	}
}


